// extracted by mini-css-extract-plugin
module.exports = {"comments_wrapper":"comment_comments_wrapper__2L4SM","comment":"comment_comment__3shAv","badge":"comment_badge__1g5gn"};